import { IFormConfig } from '../interfaces/FormConfig';

let formConfig: IFormConfig = {
  requiredFieldTip: '',
  autoInsertFormFieldGroup: false,
  urlMappings: {

  },
  urlMappingsRelatedData : {

  },
  formOverrides : {

  },
  parameterMappings : {

  },
  outputMappings : {

  },
  datasourceConditions: {
    
  }
};

export class FormConfigService {
  public static setFormConfig(incomingFormConfig: IFormConfig) {
    formConfig = incomingFormConfig;
  }

  public static getFormConfig() {
    return formConfig;
  }
}